/* eslint-disable max-len */
import 'react';

const HelpBookSvg = (
    props: React.SVGProps<SVGSVGElement>
): React.PropsWithoutRef<React.ReactSVGElement> => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
            <mask id="mask0_8069_9204" style={{'maskType': 'alpha'}} maskUnits="userSpaceOnUse" x="0" y="0" width="14" height="14">
                <rect width="14" height="14" fill="#D9D9D9" />
            </mask>
            <g mask="url(#mask0_8069_9204)">
                <path d="M7 12.25C9.8995 12.25 12.25 9.8995 12.25 7C12.25 4.10051 9.8995 1.75 7 1.75C4.10051 1.75 1.75 4.10051 1.75 7C1.75 9.8995 4.10051 12.25 7 12.25Z" stroke="#717886" strokeWidth="0.875" />
                <path d="M7 6.4082V9.35354" stroke="#717886" strokeWidth="0.875" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M7.58366 4.66634C7.58366 4.34418 7.32249 4.08301 7.00033 4.08301C6.67816 4.08301 6.41699 4.34418 6.41699 4.66634C6.41699 4.98851 6.67816 5.24967 7.00033 5.24967C7.32249 5.24967 7.58366 4.98851 7.58366 4.66634Z" fill="#717886" />
            </g>
        </svg>
    );
};

export default HelpBookSvg;
